// SPDX-License-Identifier: AGPL-3.0-or-later

import {Slider} from '@app/features/ui/components/Slider';
import styles from '@app/features/voice_scene/components/VoiceSceneAmbienceControl.module.css';
import VoiceSceneSettings from '@app/features/voice_scene/state/VoiceSceneSettings';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {FootprintsIcon, SpeakerXIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

const FOOTSTEPS_DESCRIPTOR = msg({
	message: 'Footsteps',
	comment:
		'Voice call 3D room: label and accessible name of the slider for how loud the footsteps of walking characters play. Remembered on this device.',
});
const FOOTSTEPS_VALUE_DESCRIPTOR = msg({
	message: '{percent}%',
	comment:
		'Voice call 3D room: spoken value of the footsteps slider. {percent} is a number from 1 to 200; 100 is the normal loudness.',
});
const FOOTSTEPS_OFF_DESCRIPTOR = msg({
	message: 'Off',
	context: 'voice-scene-footsteps',
	comment: 'Voice call 3D room: spoken value of the footsteps slider at 0, where footsteps are off.',
});

// How loud footsteps play, 0 (off) to 200, 100 as made; the setting itself is 0 to 2.
export const VoiceSceneFootstepControl = observer(function VoiceSceneFootstepControl() {
	const {i18n} = useLingui();
	const label = i18n._(FOOTSTEPS_DESCRIPTOR);
	const percent = Math.round(VoiceSceneSettings.footstepVolume * 100);
	const Icon = percent === 0 ? SpeakerXIcon : FootprintsIcon;
	return (
		<div className={styles.control} data-flx="voice-scene.voice-scene-footstep-control.control">
			<Icon className={styles.icon} aria-hidden="true" data-flx="voice-scene.voice-scene-footstep-control.icon" />
			<span className={styles.label} data-flx="voice-scene.voice-scene-footstep-control.label">
				{label}
			</span>
			<div className={styles.slider} data-flx="voice-scene.voice-scene-footstep-control.slider-wrap">
				<Slider
					mini
					value={percent}
					defaultValue={percent}
					factoryDefaultValue={100}
					minValue={0}
					maxValue={200}
					step={1}
					ariaLabel={label}
					ariaValueText={
						percent === 0 ? i18n._(FOOTSTEPS_OFF_DESCRIPTOR) : i18n._(FOOTSTEPS_VALUE_DESCRIPTOR, {percent})
					}
					onValueChange={(value) => VoiceSceneSettings.setFootstepVolume(Math.round(value) / 100)}
					data-flx="voice-scene.voice-scene-footstep-control.slider"
				/>
			</div>
		</div>
	);
});
